import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceOverviewRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-overview',
	path: '/jira/settings/system/performance/overview',
};
